// Copied from Youwell.Platform.Web
import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import {
    Typography, CircularProgress, List, ListItem, ListItemText, ListItemIcon,
} from '@material-ui/core';

import * as AuthStore from '../../../app/store/AuthStore';
import urls from '../../../app/urls';
import { OrgIcon, PlusIcon } from '../../../common/icons';
import { withSchools } from '../../../common/withSchools';

const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        background: theme.colors.grey1,
        display: 'flex',
        flexDirection: 'column',
    },

    content: {
        marginTop: theme.spacing(3),
        minHeight: 300,
    },

    header: {
        marginBottom: theme.spacing(3),
    },

    description: {
        marginBottom: theme.spacing(3),
    },

    select: {
        background: theme.palette.common.white,
    },

    progress: {
        marginTop: theme.spacing(1),
    },
    error: {
        marginTop: theme.spacing(1),
    },
});

class SelectSchool extends React.Component {
    onSelect = schoolId => () => this.props.selectSchool(schoolId, { redirect: urls.inside.home });

    onSelectNew = () => this.props.history.push(urls.inside.school.new);

    render() {
        const {
            classes, errorMessage, loading, schools,
        } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.content}>
                    <Typography variant="h6" className={classes.header}>
                        <Translate id="header.selectSchool" />
                    </Typography>

                    <div className={classes.description}>
                        <Typography>
                            <Translate id="header.hi" />
                        </Typography>
                        <Typography>
                            <Translate id="header.selectSchoolDescription" />
                        </Typography>
                    </div>

                    <div className={classes.select}>
                        <List component="nav">
                            {schools.map(({ id, name }) => (
                                <ListItem key={id} button onClick={this.onSelect(id)}>
                                    <ListItemIcon>
                                        <OrgIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={name} />
                                </ListItem>
                            ))}
                            <ListItem button onClick={this.onSelectNew}>
                                <ListItemIcon>
                                    <PlusIcon />
                                </ListItemIcon>
                                <ListItemText primary={<Translate id="register.school" />} />
                            </ListItem>
                        </List>
                    </div>
                    {loading && <CircularProgress className={classes.progress} />}
                    {errorMessage && (
                        <Typography className={classes.error} color="secondary">
                            {errorMessage}
                        </Typography>
                    )}
                </div>
            </div>
        );
    }
}

SelectSchool.propTypes = {
    classes: PropTypes.object.isRequired,
    selectSchool: PropTypes.func.isRequired,
    schools: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    errorMessage: PropTypes.string,
    history: PropTypes.object.isRequired,
};

SelectSchool.defaultProps = {
    loading: false,
    errorMessage: null,
};

const mapStateToProps = state => ({
    loading: state.auth.loading,
    errorMessage: [].concat(state.auth.errors).filter(val => val).join('<br/>'),
});

const mapDispatchToProps = dispatch => ({
    selectSchool: bindActionCreators(AuthStore.actionCreators, dispatch).selectOrganization,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withSchools(SelectSchool))));
